export default __webpack_public_path__ + "static/media/hero-formation-bg.0e30ab66.png";